import React from "react";
import { Table, Tag, Button } from "antd";
import { getStatusColor } from "../../../lib/utils";

const InvoiceTable = ({ facturas, loading, showFacturaDetails }) => {
  const columns = [
    {
      title: "Consecutivo",
      dataIndex: "consecutivo",
      key: "consecutivo",
    },
    {
      title: "Cliente",
      dataIndex: ["cliente", "first_name"],
      key: "cliente",
      render: (_, record) =>
        `${record.cliente?.first_name || ""} ${
          record.cliente?.last_name || ""
        }`,
    },
    {
      title: "Vendedor",
      dataIndex: ["vendedor_factura", "first_name"],
      key: "vendedor",
      render: (_, record) =>
        `${record.vendedor_factura?.first_name || ""} ${
          record.vendedor_factura?.last_name || ""
        }`,
    },
    {
      title: "Fecha",
      dataIndex: "date_created",
      key: "fecha",
      render: (date) => new Date(date).toLocaleDateString(),
    },
    {
      title: "Tipo",
      dataIndex: "estado",
      key: "estado",
      render: (estado) => (
        <Tag color={getStatusColor(estado)}>
          {estado?.toUpperCase() || "N/A"}
        </Tag>
      ),
      filters: [
        { text: "Creada", value: "creada" },
        { text: "Devolucion", value: "devolucion" },
        { text: "Devolución de Factura", value: "devolcion de factura" },
      ],
      onFilter: (value, record) => record.estado === value,
    },
    {
      title: "# Productos",
      dataIndex: "productos",
      key: "productos",
      render: (productos) => productos?.length || 0,
    },
    {
      title: "Acciones",
      key: "actions",
      render: (_, record) => (
        <Button type="primary" onClick={() => showFacturaDetails(record)}>
          Ver detalles
        </Button>
      ),
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={facturas}
      rowKey="id"
      loading={loading}
      pagination={false}
    />
  );
};

export default InvoiceTable;
